import React, { FC, useEffect } from 'react'
import { useMemo } from 'react'
import { ToastProps } from 'react-toast-notifications'
import ToastError from '../Icons/ToastError'
import ToastSuccess from '../Icons/ToastSuccess'

import './ToastNotification.scss'

enum APPEARANCE_TYPE {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning'
}

export enum TOAST_MESSAGE {
  //success messages
  CHANGE_SAVED = 'Changes saved',
  POST_APPROVED = 'Post approved',
  POST_UNAPPROVED = 'Post unapproved',
  REVISION_REQUESTED = 'Revision requested',
  POST_SENT_FOR_APPROVAL = 'Sent for approval',
  POST_DELETED = 'Post deleted',
  POSTS_DELETED = 'Posts deleted',
  PROJECT_DELETED = 'Project deleted',
  LABEL_DELETED = 'Label deleted',
  LABEL_ADDED = 'Label added',
  THE_CONTENT_HAS_BEEN_SUCCESSFULLY_PUBLISHED = 'The content has been successfully published',
  QUESTION_SENT = 'Question was sent',
  ANSWER_SENT = 'Answer was sent',
  NOTE_SENT = 'Note was sent',
  CARD_ADDED = 'Card added',
  CARD_UPDATED = 'Card updated',
  BILLING_ADDRESS_SAVED = 'Billing address saved',
  ATTCHMENT_REMOVED = 'Attachment removed',
  NOTES_UPDATED = 'Notes updated',
  NOTIFICATION_UPDATED = 'Settings updated',
  HASH_UPDATED = 'Hashtag updated',
  HASH_DELETED = 'Hashtag deleted',
  //success messages
  //error messages
  GENERAL_ERROR_MASSEGE = 'An error has occured\n Please try again!',
  THE_CONTENT_HAS_NOT_BEEN_PUBLISHED = "An error occurred. The content hasn't been published",
  THE_CONTENT_HAS_NOT_BEEN_SCHEDULED = "An error occurred. The content hasn't been scheduled",
  MAX_FILE_SIZE_OF_VIDEO = 'The size of the video file must be less than 200 MB',
  ACCOUNT_WAS_BLOCKED = 'Account was blocked',
  NOTIFICATION_DAYS_MISSSING = 'Notification days not selected',
  INTERNAL_APPROVER_ERROR_MASSEGE = 'Please add internal approver. contact Admin',
  INTERNAL_APPROVER_OPTIONAL_ERROR_MASSEGE = 'Please add internal and external (optional)\n approver. contact Admin',
  EXTERNAL_APPROVER_ERROR_MASSEGE = 'Please add external approver. contact Admin',
  APPROVER_ERROR_MASSEGE = 'Please add internal and external approver\n contact Admin',
  MAX_FILE_SIZE_OF_VIDEO_TWITTER = 'The size of the video file must be less than 11 MB',
  //error messages

  USER_HAVE_POST_TO_APPROVE = 'User have post to approve. Not able to delete',
  USER_NOT_DELETED = 'User not deleted. please check'
}

const ToastNotification: FC<ToastProps> = ({ appearance, onDismiss, children }) => {
  const closeToast = () => {
    onDismiss()
  }

  useEffect(() => {
    setTimeout(() => closeToast(), 4000)
  }, [])

  const ToastIcon = useMemo(() => {
    switch (appearance) {
      case APPEARANCE_TYPE.SUCCESS:
        return ToastSuccess
      case APPEARANCE_TYPE.ERROR:
        return ToastError
      default:
        return ToastSuccess
    }
  }, [appearance])

  return (
    <div className='toast-wrapper'>
      <div className='toast'>
        <div className={`toast_indicator toast_indicator_${appearance}`}>
          <ToastIcon />
        </div>
        <div className='toast_body'>{children}</div>
        <div className='toast_close-button' onClick={closeToast}></div>
      </div>
    </div>
  )
}

export default ToastNotification
